__turbopack_context__.v({
  "arrow": "breadcrumbs-module-scss-module__8rik6W__arrow",
  "breadcrumb": "breadcrumbs-module-scss-module__8rik6W__breadcrumb",
  "breadcrumbs": "breadcrumbs-module-scss-module__8rik6W__breadcrumbs",
  "current": "breadcrumbs-module-scss-module__8rik6W__current",
  "link": "breadcrumbs-module-scss-module__8rik6W__link",
});
